import React, { PropsWithChildren } from 'react';
import { IPage } from '@common/types/element';

type Props = PropsWithChildren<{
  screen: IPage;
}>;

const TrackPlayerWrapper: React.FC<Props> = ({ children }) => {
  return <>{children}</>;
};

export default TrackPlayerWrapper;
